import React from "react"
import {MainCP} from "../../Components/dependiente_vs_independiente/MainCP"

const ViewFelicidadEstadoDeAnimo: React.FC = () => <MainCP/>

export default ViewFelicidadEstadoDeAnimo;